export default "__VITE_ASSET__COrKPVCU__"